module.exports = __webpack_public_path__ + "img/karbach-brewing-sky-porch.49f23362.jpg";